module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iterators.js
// module id = 72
// module chunks = 2